export const SET_USER = 'set_user'


// WEBPACK FOOTER //
// ./src/store/types/user.js